<template>
  <el-container class="baohus" >
    <el-row :style="{'width': screenWidth+'px','height': screenHeight+'px','background-color': '#fff'}">
      <h4 style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">{{data['name']}}</h4>
      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">
          {{data['content']}}

      </p>


    </el-row>
  </el-container>

</template>

<script>
  export default {
    data() {
      return {

        screenWidth : window.innerWidth,
        screenHeight : window.innerHeight,
        id:this.$route.query.id,
        data:'',

      };
    },
    mounted() {


      },
      beforeDestroy() {

      },
    created() {

      this.loadList()




    },
    methods:{
      loadList(){
        const axiosInstance = this.$axios.create({
        	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
        	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
        });
        axiosInstance({
        	method:'get',
        	params:{
            id:this.id,


        	},
        	url:'https://tossp.yoooooo.com/index.php/index/data/zhuchiGetdataJsf',

        })
        .then(res=>{
          this.data = res.data.data;

          // console.log(this.list)


        })
        .catch(err=>{

        });
      },
      msg(msg,type){
      	this.$message({
      	  message: msg,
      	  type: type
      	});
      },
    },
  }
</script>

<style>
  h2{
  		text-align: center;
  	}
  	p{
  		margin:0 0 0 25px;
  		line-height: 25px;
  	}
  	h4{
  		margin:5 0 5 0;
  	}


</style>



// WEBPACK FOOTER //
// src/components/main/jianshen/zhuchi.vue